import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer1 from "../components/Footer1";
import axios from "axios";
import "./MyOrders.css";
import { useNavigate } from "react-router-dom";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
    window.scrollTo(0, 0);
  }, []);

  const fetchOrders = async () => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/signUp");
      return;
    }

    try {
      const res = await axios.get("http://localhost:8080/api/orders/my", {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Sort by newest first
      const sortedOrders = res.data.sort((a, b) => b.id - a.id);
      setOrders(sortedOrders);
    } catch (err) {
      console.error("Error fetching orders:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleViewDetails = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

  const getStatusClass = (status) => {
    const s = status?.toUpperCase();
    if (s === "PAID" || s === "DELIVERED") return "status-success";
    if (s === "PENDING" || s === "SHIPPED") return "status-warning";
    if (s === "FAILED" || s === "CANCELLED") return "status-danger";
    return "status-neutral";
  };

  const getTrackingStep = (status) => {
    const s = status?.toUpperCase();
    if (s === "DELIVERED") return 3;
    if (s === "SHIPPED") return 2;
    if (s === "PAID" || s === "PENDING") return 1;
    return 0;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
        <p>Loading Orders...</p>
      </div>
    );
  }

  return (
    <>
      {/* <Navbar /> */}
      
      <div className="top_banner_orders">
        <h1>My Collection</h1>
        <p>History of your artistic acquisitions</p>
      </div>

      <div className="orders-container">
        <h2 className="orders-heading">Order History</h2>

        <div className="orders-table-container">
          <table className="orders-table">
            <thead>
              <tr>
                <th>Order ID</th>
                <th>Date</th>
                <th>Status</th>
                <th>Total Amount</th>
                <th>Items</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center" style={{ padding: "40px" }}>
                    <p style={{ color: "#777" }}>No orders found. Start collecting art!</p>
                    <button 
                        className="btn-view-details" 
                        style={{marginTop: "10px"}}
                        onClick={() => navigate("/allPaintings")}
                    >
                        Browse Gallery
                    </button>
                  </td>
                </tr>
              ) : (
                orders.map((order) => (
                  <tr key={order.id} className="table-row">
                    <td data-label="Order ID">
                        <span className="order-id-text">#{order.orderNumber || order.id}</span>
                    </td>
                    <td data-label="Date">{formatDate(order.createdAt || Date.now())}</td>
                    <td data-label="Status">
                      <span className={`status-pill ${getStatusClass(order.status)}`}>
                        {order.status}
                      </span>
                    </td>
                    <td data-label="Total Amount">
                        <strong>₹ {order.totalAmount?.toLocaleString("en-IN")}</strong>
                    </td>
                    <td data-label="Items">
                      {order.items.length} Painting{order.items.length > 1 ? "s" : ""}
                    </td>
                    <td data-label="Action">
                      <button
                        className="btn-view-details"
                        onClick={() => handleViewDetails(order)}
                      >
                        View Details
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Order Details Modal */}
      {showModal && selectedOrder && (
        <div className="order-modal-overlay">
          <div className="order-modal-box">
            <div className="modal-header">
                <h2 className="order-modal-title">Order Details</h2>
                <span className={`status-pill ${getStatusClass(selectedOrder.status)}`}>
                    {selectedOrder.status}
                </span>
            </div>
            
            <p className="order-modal-subtext">
              Order ID: <strong>#{selectedOrder.orderNumber || selectedOrder.id}</strong> <br/>
              Placed on: {formatDate(selectedOrder.createdAt || Date.now())}
            </p>

            <div className="modal-scroll-content">
                
                {/* Visual Tracking Stepper */}
                <div className="tracking-container">
                    <div className="stepper-wrapper">
                        <div className={`stepper-item completed`}>
                            <div className="step-counter"><i className="fa-solid fa-clipboard-check"></i></div>
                            <div className="step-name">Ordered</div>
                        </div>
                        <div className={`stepper-item ${getTrackingStep(selectedOrder.status) >= 2 ? "completed" : ""}`}>
                            <div className="step-counter"><i className="fa-solid fa-truck-fast"></i></div>
                            <div className="step-name">Shipped</div>
                        </div>
                        <div className={`stepper-item ${getTrackingStep(selectedOrder.status) >= 3 ? "completed" : ""}`}>
                            <div className="step-counter"><i className="fa-solid fa-house-chimney"></i></div>
                            <div className="step-name">Delivered</div>
                        </div>
                    </div>

                    {selectedOrder.status === "SHIPPED" || selectedOrder.status === "DELIVERED" ? (
                        <div className="tracking-info-box">
                            <p><strong>Courier:</strong> {selectedOrder.courierName || "Standard Shipping"}</p>
                            <p><strong>Tracking #:</strong> {selectedOrder.trackingNumber || "N/A"}</p>
                            <p><strong>Est. Delivery:</strong> {selectedOrder.estimatedDelivery || "Coming Soon"}</p>
                            {selectedOrder.trackingUrl && (
                                <a 
                                    href={selectedOrder.trackingUrl} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="btn-track-link"
                                >
                                    Track on Courier Site <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                </a>
                            )}
                        </div>
                    ) : (
                        <div className="tracking-info-pending">
                            <i className="fa-solid fa-box-open"></i> We are packing your art with care. Tracking info will appear here soon.
                        </div>
                    )}
                </div>

                <hr className="divider" />

                <h4 className="section-title">Items Ordered</h4>
                <div className="order-items-list">
                {selectedOrder.items.map((item, index) => (
                    <div key={index} className="order-item-card">
                        <div className="item-icon">
                            {item.imageUrl ? (
                                <img src={item.imageUrl} alt={item.title} style={{width: "100%", height: "100%", objectFit: "cover", borderRadius: "8px"}} />
                            ) : <i className="fa-solid fa-palette"></i>}
                        </div>
                        <div className="item-details">
                            <h5>{item.title}</h5>
                            <p>By {item.artist}</p>
                        </div>
                        <div className="item-price">₹ {item.price?.toLocaleString("en-IN")}</div>
                    </div>
                ))}
                </div>
                
                <hr className="divider" />
                
                <h4 className="section-title">Shipping Address</h4>
                {selectedOrder.shippingAddress ? (
                    <div className="address-box">
                        <p><strong>{selectedOrder.shippingAddress.fullName}</strong></p>
                        <p>{selectedOrder.shippingAddress.addressLine}</p>
                        <p>{selectedOrder.shippingAddress.city}, {selectedOrder.shippingAddress.pincode}</p>
                        <p><i className="fa-solid fa-phone"></i> {selectedOrder.shippingAddress.mobile}</p>
                    </div>
                ) : <p>Address not available</p>}

            </div>

            <div className="order-modal-footer">
                <div className="total-row">
                    <span>Total:</span>
                    <span className="total-val">₹ {selectedOrder.totalAmount?.toLocaleString("en-IN")}</span>
                </div>
                <button className="btn-close-modal" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}

      <Footer1 />
    </>
  );
};

export default MyOrders;